import { ExternalId } from '@blk/awt-aladdinwealthserver';
import { awApiWithPkg } from './Base';

export type EventWebhookType = 'launchDeepDive' | 'launchProposalModal';

interface Payload {
  event: EventWebhookType;
  metadata: {}; // For reference only, empty for now
  portfolios: ExternalId[];
}

export function postEventsWebhook(payload: Payload, url: string) {
  return awApiWithPkg.post<null>(url, payload);
}
